/* v21 S4 tier 2 -- moved from sections/product-tab.liquid (was inline). Homepage product tab switcher. Pure DOM, no Liquid. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tabs').forEach(function (tabContainer) {
      var links = tabContainer.querySelectorAll('.tab-link');
      if (!links.length) return;

      var activeLink = links[0];
      activeLink.classList.add('active');

      // Hide all tab content except the first
      for (var i = 1; i < links.length; i++) {
        var id = links[i].getAttribute('data-tab');
        var panel = document.querySelector(id);
        if (panel) panel.style.display = 'none';
      }

      // Handle click
      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();

          // Hide current active
          var currentTab = activeLink.getAttribute('data-tab');
          var currentPanel = document.querySelector(currentTab);
          activeLink.classList.remove('active');
          if (currentPanel) currentPanel.style.display = 'none';

          // Show clicked
          activeLink = this;
          var newTab = activeLink.getAttribute('data-tab');
          var newPanel = document.querySelector(newTab);
          activeLink.classList.add('active');
          if (newPanel) newPanel.style.display = 'flex';

          // Scroll clicked tab to center on mobile
          this.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });
    });
  });
